import React, { useEffect, useState } from 'react';
import { useSiteContent } from '../../context/SiteContentContext';
import './IndustriesWeServe.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

const GRADIENTS = [
  'linear-gradient(135deg, #334155 0%, #1e293b 50%, #0f172a 100%)',
  'linear-gradient(135deg, #404040 0%, #262626 50%, #171717 100%)',
  'linear-gradient(135deg, #0e7490 0%, #0c4a6e 50%, #082f49 100%)',
  'linear-gradient(135deg, #ea580c 0%, #c2410c 50%, #9a3412 100%)',
  'linear-gradient(135deg, #64748b 0%, #475569 50%, #334155 100%)',
  'linear-gradient(135deg, #4b5563 0%, #374151 50%, #1f2937 100%)',
  'linear-gradient(135deg, #059669 0%, #047857 50%, #065f46 100%)',
  'linear-gradient(135deg, #d97706 0%, #b45309 50%, #92400e 100%)',
];

const DEFAULT_TITLE = 'Industries We Serve';
const DEFAULT_INTRO = 'HKI Industries proudly serves a diverse array of industries, including manufacturing, energy, oil & gas, and more. Our products are designed to meet the highest standards across every sector we support.';
const DEFAULT_ITEMS = [
  { name: 'Oil & Gas', image: 'oil-gas.svg' },
  { name: 'Chemical Industry', image: 'chemical.svg' },
  { name: 'Water & Waste Water', image: 'water.svg' },
  { name: 'Power & Energy', image: 'power.svg' },
  { name: 'Cement Plants', image: 'cement.svg' },
  { name: 'Metallurgical & Steel', image: 'steel.svg' },
  { name: 'Pharmaceutical', image: 'pharma.svg' },
  { name: 'Paper & Sugar Plants', image: 'paper.svg' },
];

const IndustriesWeServe = () => {
  const [imageErrors, setImageErrors] = useState({});
  const { siteContent } = useSiteContent();

  const items =
    Array.isArray(siteContent?.industries_serve_items) && siteContent.industries_serve_items.length > 0
      ? siteContent.industries_serve_items
      : DEFAULT_ITEMS;

  useEffect(() => {
    setImageErrors({});
  }, [items]);

  const title = siteContent?.industries_serve_title ?? DEFAULT_TITLE;
  const intro = siteContent?.industries_serve_intro ?? DEFAULT_INTRO;

  const getImageUrl = (item) => {
    if (!item.image) {
      return null;
    }

    if (item.image.startsWith('http')) {
      return item.image;
    }

    if (item.image.includes('storage/')) {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const path = item.image.startsWith('/') ? item.image : `/${item.image}`;
      return origin + path;
    }

    const path = (PUBLIC_URL + '/industries/' + item.image.replace(/^\/+/, '')).replace(/\/+/g, '/');
    return (typeof window !== 'undefined' ? window.location.origin : '') + path;
  };

  return (
    <section className="industries-we-serve">
      <div className="industries-container">
        <h2 className="industries-title">{title}</h2>
        {intro && <p className="industries-intro">{intro}</p>}
        <div className="industries-grid">
          {items.map((industry, index) => {
            const imageUrl = getImageUrl(industry);
            const gradient = GRADIENTS[index % GRADIENTS.length];

            return (
              <div key={index} className="industry-card">
                <div
                  className="industry-image-wrap industry-placeholder"
                  style={{ background: gradient }}
                >
                  {imageUrl && !imageErrors[index] ? (
                    <img
                      src={imageUrl}
                      alt={`${industry.name || 'Industry'} solutions served by Hari Krishna Industries`}
                      className="industry-image"
                      loading="lazy"
                      decoding="async"
                      onError={() => setImageErrors((previousErrors) => ({
                        ...previousErrors,
                        [index]: true,
                      }))}
                    />
                  ) : (
                    <span className="industry-icon">{(industry.name || ' ').charAt(0)}</span>
                  )}
                </div>
                <h3 className="industry-name">{industry.name || ' '}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesWeServe;
